import React from "react";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

const ToggleButtonCustom = ({ checked, onChange }: Props) => {
  return (
    <label className="flex cursor-pointer select-none items-center">
      <div className="relative">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only"
        />
        <div
          className={`box block h-5 w-8 rounded-full transition-colors duration-200 ${
            checked ? "bg-[#65C466]" : "bg-[#E9E9EA]"
          }`}
        ></div>
        <div
          className={`absolute left-0.5 top-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-white transition-transform duration-200 ${
            checked ? "translate-x-3" : ""
          }`}
        ></div>
      </div>
    </label>
  );
};

export default ToggleButtonCustom;
